import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function CreateCoupon(newcoupon) {
  
  try {
    const response = await axiosInstance.post('coupon/createCoupon', newcoupon);
   
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
